import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from '../../i18n/provider';
import { seoConfig } from '../../utils/seoConfig';
import PageShell from '../layout/PageShell';
import styles from './AboutPage.module.css';

const AboutPage: React.FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet>
        <title>{seoConfig.about?.title || 'About - Gym Planner'}</title>
        <meta name="description" content={seoConfig.about?.description || 'Learn about Gym Planner application'} />
        {seoConfig.about?.keywords && <meta name="keywords" content={seoConfig.about.keywords} />}
        <meta property="og:title" content={seoConfig.about?.title || 'About - Gym Planner'} />
        <meta property="og:description" content={seoConfig.about?.description || 'Learn about Gym Planner application'} />
        <meta property="og:type" content="website" />
        <meta name="twitter:title" content={seoConfig.about?.title || 'About - Gym Planner'} />
        <meta name="twitter:description" content={seoConfig.about?.description || 'Learn about Gym Planner application'} />
        <meta name="twitter:card" content="summary" />
      </Helmet>
      <PageShell variant="content">
        <div className={styles.aboutHeader}>
          <div className={styles.infoIcon}>
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"></circle>
              <line x1="12" y1="16" x2="12" y2="12"></line>
              <line x1="12" y1="8" x2="12.01" y2="8"></line>
            </svg>
          </div>
          <h1 className="content-title">{t('about.title')}</h1>
        </div>
        <div className={styles.aboutContent}>
          <div className={styles.section}>
            <p>
              {t('about.serverSlow')}
              <p/>
              {t('about.description')}
            </p>
          </div>
          <div className={styles.version}>
            <p>
              <strong>{t('about.lastUpdated')}</strong> {t('about.lastUpdatedDate')}
            </p>
          </div>
        </div>
      </PageShell>
    </>
  );
};

export default AboutPage;